<template>
    <hsc-window-style-metal>
        <hsc-window
            :closeButton="closeButton"
            :isOpen.sync="isOpen"
            :resizable="true"
            :isScrollable="true"
            :minWidth="minWidth"
            :minHeight="minHeight"
            :maxWidth="maxWidth"
            :maxHeight="maxHeight"
            :position-hint="positionHint"
            :title="title"
        >
            <slot />
        </hsc-window>
    </hsc-window-style-metal>
</template>

<script lang="ts">
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        closeButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        isOpen: {
            type: Boolean,
            required: false,
            default: true,
        },
        minWidth: {
            type: Number,
            required: false,
            default: undefined,
        },
        minHeight: {
            type: Number,
            required: false,
            default: undefined,
        },
        maxWidth: {
            type: Number,
            required: false,
            default: undefined,
        },
        maxHeight: {
            type: Number,
            required: false,
            default: undefined,
        },
        positionHint: {
            type: String,
            required: false,
            default: undefined,
        },
    },
};
</script>
